import React from "react";
import styles from "./PublishingProcessSteps.module.css";

const stepsData = [
  {
    step: "STEP 1",
    title: "무료 상담 & 원고 피드백",
    description:
      "원고만 있으면 끝!\n전문 편집자가 직접 읽고, 출간 가능성과 방향을 구체적으로 제안드립니다.\n상담은 무료입니다. 부담 없이 시작하세요.",
  },
  {
    step: "STEP 2",
    title: "계약 및 기획",
    description:
      "출판 목적과 예산, 원고 성격에 맞춰~\n자비·반기획·글로벌 출판 중 가장 적합한 방식을 제안드립니다.\n계약 후 출간 일정, 판형, 콘셉트를 함께 설계합니다.",
  },
  {
    step: "STEP 3",
    title: "편집 및 디자인",
    description:
      "책은 결국 완성도가 말해줍니다.\n전문 편집자가 원고를 다듬고,\n독자의 시선을 사로잡는 표지·내지 디자인까지 책임집니다.",
  },
  {
    step: "STEP 4",
    title: "인쇄 및 유통",
    description:
      "소량부터 인쇄 가능! 재고 걱정 없이 원하는 수량만 제작\n온라인 서점(YES24, 알라딘, 교보문고 등) 등록까지 한 번에 처리해드립니다.",
  },
  {
    step: "STEP 5",
    title: "마케팅 및 사후관리",
    description:
      "SNS 콘텐츠, 체험단, 리그램 등 실용적인 마케팅을 기본 제공\n저자 인터뷰, 후기 큐레이션, 독자 관리까지 사후 지원도 함께합니다.",
  },
];

const PublishingProcessSteps = () => {
  return (
    <section className={styles.publishingProcessStepsSection}>
      <div className={styles.publishingProcessStepsContainer}>
        <span>
          복잡한 절차는 NO! 막막했던 출간, 이제 출판 전문가와 함께 하세요.
        </span>
        <h1>쉽고 빠른 5단계 출판 과정</h1>
        <div className={styles.stepsWrapper}>
          {stepsData.map((item, index) => (
            <React.Fragment key={item.step}>
              <div className={styles.stepRow}>
                <div className={styles.publishingProcessStep}>
                  <span className={styles.stepBadge}>{item.step}</span>
                  <h2 className={styles.stepTitle}>{item.title}</h2>
                </div>
                <p className={styles.stepDescription}>{item.description}</p>
              </div>
              {index < stepsData.length - 1 && (
                <div className={styles.stepConnector}>
                  <img
                    src="./images/down-arrow-step.png"
                    style={{ height: "24px", width: "24px" }}
                    alt="arrow down"
                  ></img>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PublishingProcessSteps;
